import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout";
import { DashboardPage } from "./Admin/pages/DashboardPage";
import { MyResultPage } from "./SuperAdmin/modules/MyResult/MyResultTable/MyResultPage";
import Device from "./SuperAdmin/modules/Device";
import ModelType from "./SuperAdmin/modules/ModelType";
import FrameworkDetails from "./SuperAdmin/modules/FrameworkDetails";
import DeploymentType from "./SuperAdmin/modules/DeploymentType";
import InferJobs from "./SuperAdmin/modules/InferJobs";
import DeploymentDetails from "./SuperAdmin/modules/DeploymentDetails";
import DeployedDetails from "./SuperAdmin/modules/DeployedDetails";
import AIModel from "./SuperAdmin/modules/AIModel";
import {CompanyServicePage} from "./Admin/pages/companyService";
import {NotificationSendPage} from "./Admin/pages/NotificationSendPage";
import Locations from "./SuperAdminNew/modules/Location";
import Cameras from "./SuperAdminNew/modules/Camera";
import AddSupervisor from "./SuperAdminNew/modules/AddSupervisor";
import Subscription from "./SuperAdminNew/modules/Subscriptions";
import AllCamera from "./SuperAdminNew/modules/AllCamera";
import AllCameraStatus from "./SuperAdminNew/modules/AllCameraStatus";
import AllCameraLog from "./SuperAdminNew/modules/AllCameraLogs";
import CompanyUser from "./SuperAdminNew/modules/CompanyUser";
import CompanyUserAddPage from "./SuperAdminNew/modules/CompanyUser/components/companyUser-details-edit-dialog/CompanyUserAddPage";
import ConfiguredUserDialog
  from "./SuperAdminNew/modules/CompanyUser/components/companyUser-details-edit-dialog/ConfiguredUserDialog";
import SubscriptionModelCompanyUser from "./SuperAdminNew/modules/SubscriptionModelCompanyUser";
import CameraLabelMapping from "./SuperAdminNew/modules/CameraLabelMapping";
import FrameUploader from "./SuperAdminNew/modules/FrameUploader";
import {ResultManagerUserPage} from "./SuperAdmin/ResultManger/User";
import {ResultManagerLabelPage} from "./SuperAdmin/ResultManger/label";

export default function SuperAdminBasePage(props) {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <ContentRoute path="/admin/userPage" component={CompanyServicePage} />
        <ContentRoute path="/admin/deploymentDetails" component={DeploymentDetails} />
        <ContentRoute path="/resultManager/user" component={ResultManagerUserPage} />
        <ContentRoute path="/resultManager/labels" component={ResultManagerLabelPage} />

        {/*<ContentRoute path="/admin/deployedDetails" component={DeployedDetails} />*/}
        {/*<ContentRoute path="/admin/deployedDetails" component={DeployedDetails} />*/}


        <ContentRoute path="/myResult" component={MyResultPage} />

        {/*<ContentRoute path="/users" component={Users} />*/}
        {/*<ContentRoute path="/device" component={Device} />*/}
        {/*<ContentRoute path="/modelType" component={ModelType} />*/}
        {/*<ContentRoute path="/frameworkDetails" component={FrameworkDetails} />*/}
        {/*<ContentRoute path="/deploymentType" component={DeploymentType} />*/}
        {/*<ContentRoute path="/inferJobs" component={InferJobs} />*/}
        {/*<ContentRoute path="/aiModel" component={AIModel} {...props} />*/}
        {/*/!*<ContentRoute path="/deploymentDetails" component={DeploymentDetails} />*!/*/}
        {/*/!*<ContentRoute path="/deployedDetails" component={DeployedDetails} />*!/*/}
        {/*<ContentRoute path="/dashboard" component={DashboardPage} />*/}
        {/*/!*<ContentRoute path="/users" component={CompanyServicePage} />*!/*/}
        {/*<ContentRoute path="/NotificationSend" component={NotificationSendPage} />*/}
        {/*/!*<ContentRoute path="/my-page" component={MyPage}/>*!/*/}
        {/*<ContentRoute path="/locations" component={Locations} />*/}
        {/*<ContentRoute path="/cameras" component={Cameras} />*/}
        {/*<ContentRoute path="/addSupervisor" component={AddSupervisor} />*/}
        {/*<ContentRoute path="/subscriptions" component={Subscription} />*/}
        {/*<ContentRoute path="/allCamera" component={AllCamera} />*/}
        {/*<ContentRoute path="/camera-status" component={AllCameraStatus} />*/}
        {/*<ContentRoute path="/camera-logs" component={AllCameraLog} />*/}
        {/*<ContentRoute exact path="/company/company-user" component={CompanyUser} />*/}
        {/*<ContentRoute path="/company/company-user/add-company-user" component={CompanyUserAddPage} />*/}
        {/*<ContentRoute path="/company/company-user/configure-user" component={ConfiguredUserDialog} />*/}
        {/*<ContentRoute path="/company/subscription-model" component={SubscriptionModelCompanyUser} />*/}
        {/*<ContentRoute path="/company/camera-label-mapping" component={CameraLabelMapping} />*/}
        {/*<ContentRoute path="/company/frame-uploader" component={FrameUploader} />*/}

        <Redirect to="error/error-v3" />
      </Switch>
    </Suspense>
  );
}
